import { render, staticRenderFns } from "./bookRepositoryDetail.vue?vue&type=template&id=c24e7dcc&scoped=true&"
import script from "./bookRepositoryDetail.vue?vue&type=script&lang=js&"
export * from "./bookRepositoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookRepositoryDetail.vue?vue&type=style&index=0&id=c24e7dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24e7dcc",
  null
  
)

export default component.exports